import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import IconFilter from 'components/icons/iconFilter';
const DesktopShowHideFiltersButton = t0 => {
  const $ = _c(7);
  const {
    loading,
    onClick
  } = t0;
  let t1;
  if ($[0] !== loading) {
    t1 = classNames("hidden md:flex items-center justify-center w-8 h-8 rounded-[16px] !bg-gray-light8", {
      "mt-2": loading
    });
    $[0] = loading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconFilter width={12} height={12} />;
    t3 = <span className="sr-only">Show/hide filters</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onClick || $[5] !== t1) {
    t4 = <TabletAndDesktopOnly><button type="button" onClick={onClick} data-xc="ProductListingShowHideFiltersButton" className={t1}>{t2}{t3}</button></TabletAndDesktopOnly>;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
DesktopShowHideFiltersButton.propTypes = {
  onClick: PropTypes.func,
  loading: PropTypes.bool
};
export default DesktopShowHideFiltersButton;